'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdDirectionsTransit = function MdDirectionsTransit(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 18.4v-8.4h-8.4v8.4h8.4z m-2.5 10c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5z m-9.1-10v-8.4h-8.4v8.4h8.4z m-5.9 10c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5z m7.5-25c7.3 0 13.4 0.7 13.4 6.6v15.9c0 3.2-2.7 5.7-5.9 5.7l2.5 2.5v0.9h-20v-0.9l2.5-2.5c-3.2 0-5.9-2.5-5.9-5.7v-15.9c0-5.9 6.1-6.6 13.4-6.6z' })
        )
    );
};

exports.default = MdDirectionsTransit;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/directions-transit.js
// module id = 658
// module chunks = 0